/** Extracts the piframe.js <script src="..."> URL from a previously generated iframe snippet, so
 * buildIframeCode can preserve manually-edited tag values (e.g. a custom affs8 value) across
 * regenerations instead of always resetting them back to "REPLACE_ME". */
export const extractIframeSrcUrl = (iframeHtml: string): URL | null => {
    const match = /src="([^"]+)"/.exec(iframeHtml);
    if (!match) return null;
    try {
        return new URL(match[1]);
    } catch {
        return null;
    }
};

interface BuildIframeCodeParams {
    cdnUrl?: string;
    formId: number;
    tenantSlug?: string;
    userId?: string;
    offerId: string;
    tags?: string[];
    currentIframe?: string;
}

export const buildIframeCode = ({
    cdnUrl,
    formId,
    tenantSlug,
    userId,
    offerId,
    tags = [],
    currentIframe = "",
}: BuildIframeCodeParams): string => {
    if (!tenantSlug || !userId) {
        return "";
    }

    const baseUrl = `${cdnUrl}/js/piframe.js?id=${formId}&ts=${tenantSlug}&a=${userId}&o=${offerId}`;
    const url = new URL(baseUrl);
    const baseParamKeys = new Set(["id", "ts", "a", "o"]);

    // Carry over the current value of any still-selected tag (preserves manual edits) — base
    // params are always rebuilt fresh from the current form/user selection.
    const existingUrl = extractIframeSrcUrl(currentIframe);
    if (existingUrl) {
        existingUrl.searchParams.forEach((value, key) => {
            if (!baseParamKeys.has(key) && tags.includes(key)) {
                url.searchParams.set(key, value);
            }
        });
    }

    tags.forEach((tag) => {
        if (!url.searchParams.has(tag)) {
            url.searchParams.append(tag, "REPLACE_ME");
        }
    });

    return `<div><script type="module" src="${url.toString()}"></script></div>`;
};
